import { User } from '@app/core/models';
import { Action } from '@ngrx/store';

/**
 * UserActionTypes
 */
export const enum UserActionTypes {
  LOAD_USER = '[User] Load User',
  LOAD_USER_SUCCESS = '[User] Load User Success',
  LOAD_USER_ERROR = '[User] Load User Fail',
  PATCH_USER = '[User] Patch User',
}

/**
 * LoadUser
 */
interface LoadUser extends Action {
  type: UserActionTypes.LOAD_USER;
  payload: any;
}

/**
 * LoadUserSuccess
 */
interface LoadUserSuccess extends Action {
  type: UserActionTypes.LOAD_USER_SUCCESS;
  payload: User;
}

/**
 * LoadUserError
 */
interface LoadUserError extends Action {
  type: UserActionTypes.LOAD_USER_ERROR;
  payload: any;
}

/**
 * UserActions
 */
export type UserActions = LoadUser | LoadUserSuccess | LoadUserError;
